var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "DialogTasksBankExcel", attrs: { dir: "rtl" } },
    [
      _c(
        "div",
        { staticClass: "modal-card", staticStyle: { width: "620px" } },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v("ייבוא משימות מאקסל"),
            ]),
            _c("button", {
              staticClass: "delete",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c(
                "b-field",
                { attrs: { label: "פורמט להורדה" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { loading: _vm.isFormatLoading },
                      on: { click: _vm.downloadFormat },
                    },
                    [_vm._v("הורד תבנית לדוגמה")]
                  ),
                ],
                1
              ),
              _c(
                "b-message",
                {
                  attrs: {
                    type: "is-warning",
                    "has-icon": "",
                    closable: false,
                  },
                },
                [
                  _c("div", [
                    _vm._v(" יש להעלות "),
                    _c("b", [
                      _vm._v("אך ורק קובץ אקסל (xlsx.) במבנה שהמערכת מכירה"),
                    ]),
                    _vm._v(
                      " — התבנית שלמעלה או קובץ שיוצא מהמערכת. קובץ במבנה אחר יידחה. "
                    ),
                  ]),
                  _c("div", [
                    _vm._v(" ייבוא מחליף את המשימה "),
                    _c("b", [_vm._v("במלואה")]),
                    _vm._v(" —אם קיים תא ריק "),
                    _c("b", [_vm._v("מוחק")]),
                    _vm._v(" את הערך הקיים בשדה. "),
                  ]),
                  _c("div", [
                    _vm._v(" שורה עם "),
                    _c("code", [_vm._v("task_id")]),
                    _vm._v(" ריק יוצרת משימה חדשה. "),
                    _c("code", [_vm._v("task_id")]),
                    _vm._v(" שאינו קיים בבנק פוסל את "),
                    _c("b", [_vm._v("כל")]),
                    _vm._v(" הקובץ ולא נשמר דבר. "),
                  ]),
                  _c("div", [
                    _c("code", [_vm._v("task_id")]),
                    _vm._v(" בן "),
                    _c("b", [_vm._v("8 ספרות ומעלה")]),
                    _vm._v(
                      " אינו נשמר — נוצרת משימה חדשה עם מזהה של המערכת, ובסיום הייבוא יורד קובץ מיפוי בין המזהה המקורי למזהה החדש. "
                    ),
                  ]),
                  _c("div", [
                    _vm._v(
                      " הקובץ ייפסל ולא יישמר דבר אם: יש טקסט בעמודה מספרית ("
                    ),
                    _c("code", [_vm._v("task_id")]),
                    _vm._v(", "),
                    _c("code", [_vm._v("type")]),
                    _vm._v(", "),
                    _c("code", [_vm._v("sub_type")]),
                    _vm._v(", "),
                    _c("code", [_vm._v("External_ID")]),
                    _vm._v(", "),
                    _c("code", [_vm._v("subject_id")]),
                    _vm._v(", "),
                    _c("code", [_vm._v("duration_min")]),
                    _vm._v("); אותו "),
                    _c("code", [_vm._v("task_id")]),
                    _vm._v(" או אותו "),
                    _c("code", [_vm._v("External_ID")]),
                    _vm._v(
                      " מופיע בשתי שורות; או שמשימה חדשה זהה לשורה אחרת בקובץ או למשימה שכבר קיימת בבנק. "
                    ),
                  ]),
                  _c("div", [
                    _vm._v(" דרך העבודה הבטוחה: "),
                    _c("b", [_vm._v("ייצוא ← עריכה ← ייבוא")]),
                    _vm._v(
                      ". אין לייבא קובץ שנבנה ידנית עם חלק מהעמודות בלבד. "
                    ),
                  ]),
                  _c("div", [
                    _vm._v("לא ניתן להפעיל או להשבית משימה דרך אקסל."),
                  ]),
                ]
              ),
              _c(
                "b-field",
                {
                  attrs: {
                    label: "בחירת קובץ (יש לטעון קובץ אקסל בפורמט שניתן בלבד!)",
                  },
                },
                [
                  _c(
                    "b-upload",
                    {
                      staticClass: "file-label",
                      attrs: { accept: ".xlsx" },
                      on: { input: _vm.onFilePicked },
                      model: {
                        value: _vm.file,
                        callback: function ($$v) {
                          _vm.file = $$v
                        },
                        expression: "file",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "file-cta" },
                        [
                          _c("b-icon", {
                            staticClass: "file-icon",
                            attrs: { icon: "upload" },
                          }),
                          _c("span", { staticClass: "file-label" }, [
                            _vm._v("בחירת קובץ"),
                          ]),
                        ],
                        1
                      ),
                      _vm.file
                        ? _c("span", { staticClass: "file-name" }, [
                            _vm._v(" " + _vm._s(_vm.file.name) + " "),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _vm.serverError
                ? _c("div", { staticClass: "import__errors" }, [
                    _c("p", { staticClass: "import__errors__title" }, [
                      _vm._v(_vm._s(_vm.serverError)),
                    ]),
                    _c("p", { staticClass: "import__errors__note" }, [
                      _vm._v("לא בוצע שום שינוי בבנק המשימות."),
                    ]),
                    _vm.serverErrors.length
                      ? _c(
                          "ul",
                          { staticClass: "import__errors__list" },
                          _vm._l(_vm.serverErrors, function (e, i) {
                            return _c("li", { key: i }, [_vm._v(_vm._s(e))])
                          }),
                          0
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c("b-button", {
                attrs: {
                  loading: _vm.isLoading,
                  disabled: !_vm.file,
                  type: "is-primary",
                  label: "ייבא",
                },
                on: { click: _vm.save },
              }),
              _c("b-button", {
                attrs: { disabled: _vm.isLoading, label: "ביטול" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }